/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface AnneeFormationSuivieIfapmeFichierUploadDto
 */
export interface AnneeFormationSuivieIfapmeFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof AnneeFormationSuivieIfapmeFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierUploadDto
     */
    idanneeFormationSuivieIfapmeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierUploadDto
     */
    idanneeFormationSuivieIfapme?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieIfapmeFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the AnneeFormationSuivieIfapmeFichierUploadDto interface.
 */
export function instanceOfAnneeFormationSuivieIfapmeFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeFormationSuivieIfapmeFichierUploadDtoFromJSON(json: any): AnneeFormationSuivieIfapmeFichierUploadDto {
    return AnneeFormationSuivieIfapmeFichierUploadDtoFromJSONTyped(json, false);
}

export function AnneeFormationSuivieIfapmeFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeFormationSuivieIfapmeFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idanneeFormationSuivieIfapmeFichier': !exists(json, 'idanneeFormationSuivieIfapmeFichier') ? undefined : json['idanneeFormationSuivieIfapmeFichier'],
        'idanneeFormationSuivieIfapme': !exists(json, 'idanneeFormationSuivieIfapme') ? undefined : json['idanneeFormationSuivieIfapme'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function AnneeFormationSuivieIfapmeFichierUploadDtoToJSON(value?: AnneeFormationSuivieIfapmeFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idanneeFormationSuivieIfapmeFichier': value.idanneeFormationSuivieIfapmeFichier,
        'idanneeFormationSuivieIfapme': value.idanneeFormationSuivieIfapme,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

